import { render, staticRenderFns } from "./BoxPlan.vue?vue&type=template&id=24671dde&scoped=true"
import script from "./BoxPlan.vue?vue&type=script&lang=js"
export * from "./BoxPlan.vue?vue&type=script&lang=js"
import style0 from "./BoxPlan.vue?vue&type=style&index=0&id=24671dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24671dde",
  null
  
)

export default component.exports